import React from "react";
import { BreadcrumbsContainer } from "styles/components/BreadcrumbsContainer";

const LearningLibraryBreadcrumb = () => (
  <BreadcrumbsContainer>Learning Library</BreadcrumbsContainer>
);

export default LearningLibraryBreadcrumb;
